import { forwardRef } from "react";

const ButtonModal = forwardRef(
    ({ name, type, className, onClick, disabled = false }, ref) => {
        return (
            <button
                ref={ref}
                onClick={onClick}
                type={type}
                className={className}
                disabled={disabled}
            >
                {name}
            </button>
        );
    },
);

export default ButtonModal;
